var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteTrophy = function SvgGradientWhiteTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.377 13.105v-1.367H7.643v1.367l-.684 1.367h4.102l-.684-1.367Z",
    fill: "url(#gradient-white-trophy_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.479 3.534h-2.051v-.683c0-.41-.274-.684-.684-.684H6.275c-.41 0-.683.274-.683.684v.683H3.54c-.41 0-.684.274-.684.684v2.734a2.742 2.742 0 0 0 2.735 2.735l2.05 2.05h2.735l2.05-2.05a2.742 2.742 0 0 0 2.735-2.735V4.218c0-.41-.273-.684-.683-.684ZM4.225 6.952v-2.05h1.367V8.32a1.371 1.371 0 0 1-1.367-1.368Zm9.57 0c0 .752-.615 1.368-1.367 1.368V4.902h1.367v2.05Zm-1.367 8.204v.683H5.592v-.683c0-.41.273-.684.683-.684h5.47c.41 0 .683.274.683.684ZM7.643 6.952c-.41 0-.684-.273-.684-.683v-2.05c0-.411.274-.685.684-.685.41 0 .683.274.683.684v2.05c0 .411-.273.684-.683.684Zm0 2.735c-.41 0-.684-.274-.684-.684V8.32c0-.41.274-.684.684-.684.41 0 .683.274.683.684v.683c0 .41-.273.684-.683.684Z",
    fill: "url(#gradient-white-trophy_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-trophy_svg__a",
    x1: 9.01,
    y1: 10.832,
    x2: 9.01,
    y2: 14.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-trophy_svg__b",
    x1: 9.01,
    y1: 2.167,
    x2: 9.01,
    y2: 18.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};

export default SvgGradientWhiteTrophy;